import React, { type ElementType } from 'react';

import classnames from 'classnames';

import { ActionMenu } from '../../../ActionMenu';
import { Overflow } from '../../../Overflow/Overflow';
import { useBreadcrumbContext } from '../../Breadcrumb.context';

import styles from './BreadcrumbRest.module.scss';

export type BreadcrumbRestProps = {
    as?: ElementType;
    className?: string;
};

export const BreadcrumbRest = ({ className, as = 'li', ...rest }: BreadcrumbRestProps) => {
    const { hiddenItems } = useBreadcrumbContext();
    return (
        <Overflow.Rest as={as} className={classnames(styles.container, className)} {...rest}>
            <ActionMenu
                actions={hiddenItems.map(({ id, ...restItem }) => ({
                    key: id,
                    id: String(id),
                    color: 'neutral' as const,
                    ...restItem
                }))}
                slotProps={{
                    tooltip: { hidden: true },
                    trigger: {
                        'aria-label': 'Show more',
                        type: 'ghost',
                        color: 'neutral'
                    },
                    triggerIcon: {
                        size: 'medium',
                        name: 's-icon-ellipsis-horizontal',
                        'aria-hidden': true
                    }
                }}
            />
        </Overflow.Rest>
    );
};
